export enum FinancingType {
  Internal = 0,
  External = 1
}
